webpackJsonp([14083219111809663000],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/additional-reading.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"allPostTitles": {
				"edges": [
					{
						"node": {
							"frontmatter": {
								"tocTitle": "Choosing an index type",
								"title": "Local or global: Choosing a secondary index type in DynamoDB",
								"lesson": 1,
								"chapter": 7,
								"type": "lesson"
							},
							"fields": {
								"slug": "/local-or-global-choosing-a-secondary-index-type-in-dynamo-db"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "DynamoDB Streams",
								"lesson": 4,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/dynamodb-streams"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Global Secondary Indexes",
								"lesson": 3,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/global-secondary-indexes"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Local Secondary Indexes",
								"lesson": 2,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/local-secondary-indexes"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Secondary Indexes",
								"lesson": 1,
								"chapter": 4,
								"type": "lesson"
							},
							"fields": {
								"slug": "/secondary-indexes"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "MongoDB vs. DynamoDB",
								"lesson": 1,
								"chapter": 8,
								"type": "lesson"
							},
							"fields": {
								"slug": "/mongo-db-vs-dynamo-db"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Working with Multiple Items",
								"lesson": 1,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/working-with-multiple-items"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Filtering",
								"lesson": 4,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/filtering"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Scans",
								"lesson": 3,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/scans"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Querying",
								"lesson": 2,
								"chapter": 3,
								"type": "lesson"
							},
							"fields": {
								"slug": "/querying"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Hierarchical Data",
								"lesson": 2,
								"chapter": 6,
								"type": "lesson"
							},
							"fields": {
								"slug": "/hierarchical-data"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Leaderboard & Write Sharding",
								"lesson": 3,
								"chapter": 6,
								"type": "lesson"
							},
							"fields": {
								"slug": "/leaderboard-write-sharding"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Overview",
								"lesson": 1,
								"chapter": 6,
								"type": "lesson"
							},
							"fields": {
								"slug": "/data-modeling-overview"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Backups & Restores",
								"lesson": 3,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/backups-restores"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Autoscaling",
								"lesson": 4,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/autoscaling"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Provisioning tables",
								"lesson": 1,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/provisioning-tables"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Global Tables",
								"lesson": 5,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/global-tables"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Security",
								"lesson": 2,
								"chapter": 5,
								"type": "lesson"
							},
							"fields": {
								"slug": "/security"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Additional Reading",
								"lesson": 1,
								"chapter": 9,
								"type": "lesson"
							},
							"fields": {
								"slug": "/additional-reading"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Anatomy of an Item",
								"lesson": 1,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/anatomy-of-an-item"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Inserting & Retrieving Items",
								"lesson": 2,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/inserting-retrieving-items"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Updating & Deleting Items",
								"lesson": 4,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/updating-deleting-items"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Environment Setup",
								"lesson": 4,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/environment-setup"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Expression Basics",
								"lesson": 3,
								"chapter": 2,
								"type": "lesson"
							},
							"fields": {
								"slug": "/expression-basics"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "The Dynamo Paper",
								"lesson": 3,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/the-dynamo-paper"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "Key Concepts",
								"lesson": 2,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/key-concepts"
							}
						}
					},
					{
						"node": {
							"frontmatter": {
								"tocTitle": null,
								"title": "What is DynamoDB?",
								"lesson": 1,
								"chapter": 1,
								"type": "lesson"
							},
							"fields": {
								"slug": "/what-is-dynamo-db"
							}
						}
					}
				]
			},
			"postBySlug": {
				"html": "<h3 id=\"articles\"><a href=\"#articles\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Articles:</h3>\n<ul>\n<li><a href=\"https://www.alexdebrie.com/posts/dynamodb-no-bad-queries/\">SQL, NoSQL, and Scale: How DynamoDB scales where relational databases don't</a> - This is a post of mine explaining the core architectural decisions that allow NoSQL databases to scale further than their SQL brethren. </li>\n<li><a href=\"https://www.alexdebrie.com/posts/dynamodb-single-table/\">The What, Why, and When of Single-Table Design with DynamoDB</a> - A deep look at what it means to do single-table design in DynamoDB and why you would want to. It also includes a few situations where you may want to <em>avoid</em> single-table design.</li>\n<li><a href=\"https://www.alexdebrie.com/posts/dynamodb-patterns-serverless/\">Faux-SQL or NoSQL? Examining four DynamoDB Patterns in Serverless Applications</a> - This is a post I wrote on the common data modeling patterns I see with DynamoDB in serverless applications.</li>\n<li><a href=\"https://read.acloud.guru/why-amazon-dynamodb-isnt-for-everyone-and-how-to-decide-when-it-s-for-you-aefc52ea9476\">Why Amazon DynamoDB isn't for everyone</a> - My favorite post on this topic. Forrest Brazeal does a great job breaking down the pros and cons of DynamoDB.</li>\n<li><a href=\"https://www.trek10.com/blog/dynamodb-single-table-relational-modeling/\">From relational DB to single DynamoDB table: a step-by-step exploration</a> - Another great post by Forrest Brazeal. It's a detailed walkthrough of how to use the single-table DynamoDB pattern in a complex use case.</li>\n<li><a href=\"https://www.alexdebrie.com/posts/choosing-a-database-with-pie/\">Why the PIE theorem is more relevant than the CAP theorem</a> - Another post I wrote about choosing a database that includes consideration of DynamoDB.</li>\n</ul>\n<h3 id=\"videos\"><a href=\"#videos\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Videos:</h3>\n<ul>\n<li><a href=\"https://www.youtube.com/watch?v=jzeKPKpucS0\">Advanced Design Patterns for DynamoDB (reInvent 2017)</a>. Rick Houlihan is a master of DynamoDB and has some great tips.</li>\n<li><a href=\"https://www.youtube.com/watch?v=HaEPXoXVf2k\">Advanced Design Pattens for DynamoDB (reInvent 2018)</a>. Rick Houlihan is back with more tips. The first half is similar to 2017, but the second half has different examples. Highly recommended. <a href=\"https://www.slideshare.net/AmazonWebServices/amazon-dynamodb-deep-dive-advanced-design-patterns-for-dynamodb-dat401-aws-reinvent-2018pdf\">Get the slides here</a>.</li>\n<li><a href=\"https://t.co/fRtp2X3Vgg?amp=1\">Advanced Design Patterns for DynamoDB (reInvent 2019)</a>. The most recent edition of Rick Houlihan's DynamoDB talk.</li>\n<li>Advanced Design Patterns for DynamoDB (reInvent 2020) <a href=\"https://youtu.be/MF9a1UNOAQo\">Part 1</a> &#x26; <a href=\"https://youtu.be/_KNrRdWD25M\">Part 2</a></li>\n<li>Data Modeling with DynamoDB (reInvent 2020) -- <a href=\"https://youtu.be/fiP2e-g-r4g\">Part 1</a> &#x26; <a href=\"https://youtu.be/0uLF1tjI_BI\">Part 2</a>. An intermediate level look at the concepts behind DynamoDB to understand the core data modeling principles.</li>\n<li><a href=\"https://www.youtube.com/watch?v=DIQVJqiSUkE\">Data Modeling with DynamoDB (reInvent 2019)</a>. A gentler introduction to DynamoDB single-table concepts. Watch this video if Rick's is too advanced.</li>\n<li><a href=\"https://acloud.guru/series/serverlessconf-nyc-2019/view/dynamodb-best-practices\">Using (and ignoring) DynamoDB Best Practices in Serverless (ServerlessConf NYC 2019)</a>. This talk focuses on using DynamoDB in Serverless applications.</li>\n</ul>\n<h3 id=\"reference-material\"><a href=\"#reference-material\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>Reference material:</h3>\n<ul>\n<li><a href=\"https://github.com/alexdebrie/awesome-dynamodb\">Awesome DynamoDB</a> -- A GitHub repo with DynamoDB links and resources.</li>\n<li><a href=\"https://aws.amazon.com/dynamodb/\">DynamoDB landing page</a></li>\n<li><a href=\"https://docs.aws.amazon.com/amazondynamodb/latest/developerguide/Introduction.html\">AWS Developer Guide Docs</a></li>\n<li><a href=\"https://docs.aws.amazon.com/cli/latest/reference/dynamodb/index.html\">AWS CLI reference for DynamoDB</a></li>\n<li><a href=\"http://boto3.readthedocs.io/en/latest/reference/services/dynamodb.html\">Boto3 (Python client library for AWS) docs</a></li>\n<li><a href=\"https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/DynamoDB.html\">Javascript client library for AWS</a></li>\n<li><a href=\"https://github.com/dabit3/dynamodb-documentclient-cheat-sheet\">Document Client cheat sheet (Javascript)</a>. Created by <a href=\"https://twitter.com/dabit3\">Nader Dabit</a>.</li>\n</ul>",
				"timeToRead": 3,
				"excerpt": "Articles: SQL, NoSQL, and Scale: How DynamoDB scales where relational databases don't  - This is a post of mine explaining the core...",
				"frontmatter": {
					"title": "Additional Reading",
					"date": "1/5/2020",
					"category": null,
					"description": "External resources on AWS DynamoDB"
				},
				"fields": {
					"slug": "/additional-reading"
				}
			}
		},
		"pathContext": {
			"slug": "/additional-reading"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---additional-reading-454692dfbe1006b41775.js